module.exports = __webpack_public_path__ + "tc.bca9f99cb80af8a64a12.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/tc.svg
// module id = ../../../../flag-icon-css/flags/1x1/tc.svg
// module chunks = styles